'use strict';

var _EthiopicCalendar = require('./calendar/EthiopicCalendar');

var _EthiopicCalendar2 = _interopRequireDefault(_EthiopicCalendar);

var _GregorianCalendar = require('./calendar/GregorianCalendar');

var _GregorianCalendar2 = _interopRequireDefault(_GregorianCalendar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toEthiopic = function toEthiopic(jy, jm, jd) {
    var jdn = _GregorianCalendar2.default.toJdn(jy, jm, jd);
    return _EthiopicCalendar2.default.fromJdn(jdn).toArray();
};

var toGregorian = function toGregorian(jy, jm, jd) {
    var jdn = _EthiopicCalendar2.default.toJdn(jy, jm, jd);
    return _GregorianCalendar2.default.fromJdn(jdn).toArray();
};

var isValidEthiopicDate = function isValidEthiopicDate(jy, jm, jd) {
    var valid = true;
    try {
        _EthiopicCalendar2.default.validate(jy, jm, jd);
    } catch (error) {
        valid = false;
    }
    return valid;
};

var isLeapEthiopicYear = function isLeapEthiopicYear(jy) {
    return _EthiopicCalendar2.default.isLeapYear(jy);
};

module.exports = {
    toEthiopic: toEthiopic,
    toGregorian: toGregorian,
    isValidEthiopicDate: isValidEthiopicDate,
    isLeapEthiopicYear: isLeapEthiopicYear
};